const apiEndPoints = {
  dash: {
    API_URL: 'https://api.secuseek.com/api',
    BASE_URL: 'https://dash.secuseek.com',
    cookie_domain: 'dash.secuseek.com',
    PROD_ASSETS_URL: 'https://secuseekstorage.blob.core.windows.net',
  },
  hub: {
    API_URL: 'https://api-dev.secuseek.com/api',
    BASE_URL: 'https://hub.secuseek.com',
    cookie_domain: 'hub.secuseek.com',
    PROD_ASSETS_URL: 'https://secuseekstorage.blob.core.windows.net',
  },

  dev: {
    API_URL: 'https://api-dev.secuseek.com/api' /* -dev */,
    BASE_URL: 'http://192.168.137.1:8000',
    cookie_domain: '192.168.137.1',
    PROD_ASSETS_URL: 'https://secuseekstorage.blob.core.windows.net',
  },

  local: {
    API_URL: 'https://localhost:7176/api',
    BASE_URL: 'http://localhost:3000',
    cookie_domain: 'localhost',
    PROD_ASSETS_URL: 'https://secuseekstorage.blob.core.windows.net',
  },

  userRoles: {
    Administrative: 'Administrative',
  },

  example_slug: '/file/selman/koral/{slug}/{secret_key}',

  //! _________________  start of NEW api endpoints ___________________

  auth_login: '/v1/auth/login',
  auth_register: '/v1/users/register',
  user_change_password: '/v1/users/me/change-password',
  auth_forgot_password: '/v1/auth/forgot-password',
  auth_reset_password: '/v1/auth/reset-password',
  refresh_token: '/v1/auth/refresh-token',
  get_status_2FA: '/v1/users/me/2fa',
  get_code_2FA: '/v1/users/me/2fa/setup',
  enable_2FA: '/v1/users/me/2fa/enable',
  disable_2FA: '/v1/users/me/2fa/disable',
  verify_2FA_login: '/v1/auth/2fa/verify',

  scan: '/v1/vuln/scan',
  contact_info: '/v1/users/me/contact-information',
  notifications: '/v1/notifications',
  mark_notification_read: '/v1/notifications/{id}/read',
  account_notification_get_preferences: '/v1/notification-preference',
  account_notification_patchpost_preference: '/v1/notification-preference',
  account_notification_delete_preference: '/v1/notification-preference/{id}',
  users_me_profile: '/v1/users/me/profile',
  domains: '/v1/users/me/domains',
  domain: '/v1/users/me/domains/{id}',
  email_change_request: '/v1/users/email-change-request', // newEmail
  email_change_confirm: '/v1/users/email-change-confirm', // token
  verify_domain: '/v1/users/me/domains/{id}/verify',
  anti_forgery_token: '/anti-forgery-token',

  summary_headers: '/v1/summary/{userJobScheduleId}/headers',
  summary_ports: '/v1/summary/{userJobScheduleId}/ports',
  summary_subdomains: '/v1/summary/{userJobScheduleId}/subdomains',
  summary_vulnerabilities: '/v1/summary/{userJobScheduleId}/site-vulnerabilities',

  check_url_scannability: '/v1/schedule-scan/check-url',
  scan_type_packages: '/v1/scan-type-packages',

  schedule_scan: '/v1/schedule-scan',
  scheduled_scan: '/v1/schedule-scan/{id}',
  scan_statistics: '/v1/schedule-scan/{userJobScheduleId}/statistics',
  scan_status: '/v1/schedule-scan/{id}/status',
  pause_scan: '/v1/schedule-scan/{id}/pause',
  resume_scan: '/v1/schedule-scan/{id}/resume',
  start_manual_scan: '/v1/schedule-scan/{id}/start-manual',

  report_headers: '/v1/report/{userJobScheduleId}/headers',
  report_ports: '/v1/report/{userJobScheduleId}/ports',
  report_requests: '/v1/report/{userJobScheduleId}/requests',
  report_subdomains: '/v1/report/{userJobScheduleId}/subdomains',
  report_technologies: '/v1/report/{userJobScheduleId}/site-technologies',
  report_vulnerabilities: '/v1/report/{userJobScheduleId}/site-vulnerabilities',
  report_dns_security: '/v1/report/{userJobScheduleId}/dns-security',
  report_dns_change_alerts: '/v1/report/{userJobScheduleId}/dns-change-alerts',
  report_ssl_securities: '/v1/report/{userJobScheduleId}/ssl-securities',
  report_secret_apis: '/v1/report/{userJobScheduleId}/secret-apis',
  report_malicious: '/v1/report/{userJobScheduleId}/malicious',
  report_sensitive: '/v1/report/{userJobScheduleId}/sensitive-resources',
  report_subdomain_takeovers: '/v1/report/{userJobScheduleId}/subdomain-takeovers',
  report_wafs: '/v1/report/{userJobScheduleId}/site-wafs',
  report_static_code_analyses: '/v1/report/{userJobScheduleId}/static-code-analyses',
  
  issues_findings: '/v1/issues/{websiteVulnerabilityId}',
  
  // LLM Action Plan endpoints
  llm_action_plan_get: '/v1/llm/{websiteVulnerabilityId}',
  llm_action_plan_post: '/v1/llm/{websiteVulnerabilityId}',
  llm_action_plan_retry: '/v1/llm/{websiteVulnerabilityId}/retry-action-plan',
  llm_action_plan_solve_step: '/v1/llm/{websiteVulnerabilityId}/solve-action-plan-step',
  llm_action_plan_unsolve_step: '/v1/llm/{websiteVulnerabilityId}/unsolve-action-plan-step',

  chart_headers: '/v1/charts/{userJobScheduleId}/headers',
  chart_ports: '/v1/charts/{userJobScheduleId}/ports',
  chart_subdomains: '/v1/charts/{userJobScheduleId}/subdomains',
  chart_vulnerabilities: '/v1/charts/{userJobScheduleId}/site-vulnerabilities',

  api_key_getpost: '/v1/api-key',
  
  // User Management endpoints
  users_list: '/v1/admin/users', // ?pageSize=3&pageNumber=1&name=aa&email=test || role ve status filtreleri de eklenebilir
  user_create: '/v1/admin/users',
  user_update: '/v1/admin/users/{userId}',
  user_targets: '/v1/admin/users/{userId}/schedule-scans',
  user_delete: '/v1/admin/users/{userId}',
  user_status_update: '/v1/admin/users/{userId}/status', 
  history_of_a_scan: '/v1/history/{userJobScheduleId}/{scanName}', // ?year=2025 &month=7 || Eğer year yada month değerleri gönderilmezse default olarak mevcut yıl ve ayı alacak
  
  crs_questionnaire: '/v1/cyber-risk-score/questionnaire',
  crs_profile: '/v1/cyber-risk-score/{userDomainId}/profile',
  crs_result_last: '/v1/cyber-risk-score/{userDomainId}/result/last',
  crs_result: '/v1/cyber-risk-score/{userDomainId}/result/{recordId}',
  crs_history: '/v1/cyber-risk-score/{userDomainId}/history',
  crs_ai_report: '/v1/cyber-risk-score/{userDomainId}/result/{recordId}/ai-report',

  //! _________________  end of api endpoints ___________________
};

// const { dev, prod, ...general } = apiEndPoints;
const { dash, hub, dev, local, ...general } = apiEndPoints;

//* `envConfig` will hold environment-specific configurations (prod or dev)
export const getEnvConfig = (): 'dash' | 'hub' | 'dev' | 'local' => {
  if (import.meta.env.MODE === 'localapi') return 'local';
  if (import.meta.env.MODE === 'development') return 'dev';
  return import.meta.env.VITE_APP_ENV === 'hub' ? 'hub' : 'dash';
};

//* `getApiUrl` provides the full URL based on the provided template and params
export const getApiUrl = (endpointTemplate: any, params?: any) => {
  // //? Check if the endpointTemplate exists in the apiEndPoints

  const env = getEnvConfig();
  const envConfig = apiEndPoints[env];

  let finalUrl = `${envConfig.API_URL}${endpointTemplate}`;
  if (params) {
    Object.keys(params).forEach((paramKey) => {
      const paramRegex = new RegExp(`{${paramKey}}`, 'g');
      finalUrl = finalUrl.replace(paramRegex, params[paramKey]);
    });
  }
  return finalUrl;
};

//* `getEndPoint` handles the base endpoint format (without the API_URL part)
export const getEndPoint = (endpointTemplate: any, params?: any) => {
  let finalUrl = `${endpointTemplate}`;
  if (params) {
    Object.keys(params).forEach((paramKey) => {
      const paramRegex = new RegExp(`{${paramKey}}`, 'g');
      finalUrl = finalUrl.replace(paramRegex, params[paramKey]);
    });
  }
  return finalUrl;
};

const getCrsApiBaseUrl = () => {
  const env = getEnvConfig();
  const configuredCrsApiUrl = import.meta.env.VITE_CRS_API_URL;

  if (configuredCrsApiUrl) return configuredCrsApiUrl.replace(/\/$/, '');
  if (env === 'dev') return 'https://localhost:7176/api';

  return apiEndPoints[env].API_URL;
};

export const getCrsApiUrl = (endpointTemplate: any, params?: any) => {
  return `${getCrsApiBaseUrl()}${getEndPoint(endpointTemplate, params)}`;
};

//* Helper functions to group and filter API endpoints
export const getReportEndpoints = () => {
  return Object.entries(apiEndPoints)
    .filter(([key]) => key.startsWith('report_'))
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
};
export const getSummaryEndpoints = () => {
  return Object.entries(apiEndPoints)
    .filter(([key]) => key.startsWith('summary_'))
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
};

export const getChartEndpoints = () => {
  return Object.entries(apiEndPoints)
    .filter(([key]) => key.startsWith('chart_'))
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});
};

export const getInitialEndpoints = () => {
  return {
    schedule_scan: apiEndPoints.schedule_scan,
    scan_statistics: apiEndPoints.scan_statistics,
    notifications: apiEndPoints.notifications,
    users_me_profile: apiEndPoints.users_me_profile,
  };
};

export const getScanEndpoints = () => {
  return {
    scan_type_packages: apiEndPoints.scan_type_packages,
    scan_status: apiEndPoints.scan_status,
  };
};

//* apiConfig holds the entire configuration, merging environment-specific and general settings
export const apiConfig = (() => {
  const env = getEnvConfig();
  return { ...general, ...apiEndPoints[env] };
})();
